export enum FloorAbbrForTooltip {
	NP0 = "NP0",
	NP00 = "NP00"
}
